import React, { useState } from "react";
import RGL, { WidthProvider, Layout } from "react-grid-layout";
/*//import WelComeBox from './Wedgits/welcome-box'
//import TotalAvailableOffer from './Wedgits/total-available-offer'
import TotalOpenedOffer from './Wedgits/total-opened-offer'
import TotalClosedOffer from './Wedgits/total-closed-offer'*/
import TrenderQuatationsList from "./Wedgits/treder-quatations-list";
import TotalOfferperStatus from "./Wedgits/total-offer-status";
import { TbFileInvoice } from "react-icons/tb";
import { GoPackageDependencies } from "react-icons/go";
import { LuFileBox } from "react-icons/lu";
import { FaChartLine } from "react-icons/fa";
import { useSelector } from "react-redux";
import { RootState } from "@/store/type";
import OrdersSList from "./Wedgits/OrdersSList";
import { isUndefined } from "lodash";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { ROLE } from "@/types";
import { StaticDashboard } from "@/pages/buyer/home/components/lobby/responsive/Wedgits/StaticDashboard";
import useLobby from "@/hooks/use-lobby";
import useOrder from "@/hooks/use-order";
import useProfile from "@/hooks/use-profile";
import CompleteProfile from "@/pages/buyer/home/components/lobby/responsive/Wedgits/CompleteProfile";

const ReactGridLayout = WidthProvider(RGL);

interface ExtraLargeGridProps {}

const ExtraLargeGrid: React.FC<ExtraLargeGridProps> = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const [completProfile, setCompletProfile] = useState({
    profile: true,
    company: true,
  });
  const {
    getTotaltenderQuotations,
    getTotaltenderOpenedQuotations,
    getTotaltenderClosed,
  } = useLobby();
  const { fetchOrders } = useOrder();
  const { getUserProfile } = useProfile();
  const myCompany = useSelector((state: RootState) => state.auth.myCompany);
  const [totalOffers, setTotalOffers] = useState(0);
  const [totalOrders, setTotalOrders] = useState<number>(0);
  const [totalOpenedOffers, setTotalOpenedOffers] = useState<number>(0);
  const [totalClosedOffers, setTotalClosedOffers] = useState<number>(0);
  const authUser = useSelector((state: RootState) => state.auth.authUser);
  const userRole = isUndefined(authUser?.role) ? "" : authUser?.role;
  const layout: Layout[] = [
    { i: "1", x: 0, y: 0, w: 3, h: 5, static: true },
    { i: "2", x: 3, y: 0, w: 3, h: 5, static: true },
    { i: "3", x: 6, y: 0, w: 3, h: 5, static: true },
    { i: "4", x: 9, y: 0, w: 3, h: 5, static: true },
    { i: "5", x: 0, y: 5, w: 3, h: 20, static: true },
    { i: "6", x: 3, y: 5, w: 9, h: 17, static: true },
    { i: "7", x: 3, y: 22, w: 9, h: 17, static: true },
  ];
  React.useEffect(() => {
    getUserProfile()
      .then((res) => {
        setCompletProfile({
          company: Boolean(res.data.company),
          profile: Boolean(res.data.user.phoneNumber),
        });
      })
      .catch((_) => {
        setCompletProfile({
          profile: true,
          company: true,
        });
      });
    const getTotaltenderQ = async () => {
      try {
        const Total = await getTotaltenderQuotations();
        if (Total) {
          setTotalOffers(Total.total);
        } else {
          setTotalOffers(0);
        }
      } catch (error) {
        console.error("Error fetching Offers:", error);
      }
    };
    const fetchTotalOrders = async () => {
      try {
        if (myCompany?.id) {
          const total = await fetchOrders(myCompany.id);
          if (total) {
            setTotalOrders((total.data || []).length);
          } else {
            setTotalOrders(0);
          }
        }
      } catch (err) {
        console.error("Error fetching offers:", err);
      }
    };
    const getTotalOpernedtenderQ = async () => {
      try {
        const Total = await getTotaltenderOpenedQuotations();
        if (Total) {
          setTotalOpenedOffers(Total.total);
        } else {
          setTotalOpenedOffers(0);
        }
      } catch (error) {
        console.error("Error fetching Offers:", error);
      }
    };
    const getTotalClosedtenderQ = async () => {
      try {
        const Total = await getTotaltenderClosed();
        if (Total) {
          setTotalClosedOffers(Total.total);
        } else {
          setTotalClosedOffers(0);
        }
      } catch (error) {
        console.error("Error fetching Offers:", error);
      }
    };
    getTotaltenderQ();
    getTotalOpernedtenderQ();
    getTotalClosedtenderQ();
    fetchTotalOrders();
  }, []);
  const level = () => {
    if (!completProfile.company && !completProfile.profile) {
      return "0%";
    } else if (completProfile.company && completProfile.profile) {
      return false;
    } else {
      return "50%";
    }
  };
  return (
    <div
      className="module-list-scroll scrollbar actionSidebar"
      style={{ direction: "ltr", padding: "0px 20px" }}
    >
      {level() ? (
        <CompleteProfile
          isCompany={!!completProfile?.company}
          isProfile={!!completProfile?.profile}
          level={level()}
        />
      ) : (
        ""
      )}
      <ReactGridLayout
        className="layout"
        layout={layout}
        rowHeight={18}
        isDraggable={false}
        isResizable={false}
      >
        <div
          style={{ backgroundColor: "white", zIndex: 3, borderRadius: 10 }}
          key="1"
        >
          <span className="text">
            <StaticDashboard
              day={t("general.comparedTo30Days")}
              percentage={"٤%"}
              logo={<FaChartLine />}
              title={t("general.closedOpportunities")}
              subTitle={totalClosedOffers}
            />
          </span>
        </div>
        <div
          style={{ backgroundColor: "white", zIndex: 3, borderRadius: 10 }}
          key="2"
        >
          <span className="text">
            <StaticDashboard
              day={t("general.comparedTo30Days")}
              percentage={"٤%"}
              logo={<LuFileBox />}
              title={t("general.openOpportunities")}
              subTitle={totalOpenedOffers}
            />
          </span>
        </div>
        <div
          style={{ backgroundColor: "white", zIndex: 3, borderRadius: 10 }}
          key="3"
        >
          <span className="text">
            <StaticDashboard
              day={t("general.comparedTo30Days")}
              percentage={"٤%"}
              logo={<GoPackageDependencies />}
              title={
                userRole === ROLE.SELLER
                  ? t("general.sales")
                  : t("general.Purchases")
              }
              subTitle={totalOrders}
            />
          </span>
        </div>
        <div
          style={{ backgroundColor: "white", zIndex: 3, borderRadius: 10 }}
          key="4"
        >
          <span className="text">
            <StaticDashboard
              day={t("general.comparedTo30Days")}
              percentage={"٤%"}
              logo={<TbFileInvoice />}
              title={t("general.displayedOpportunities")}
              subTitle={totalOffers}
            />
          </span>
        </div>
        <div
          style={{ backgroundColor: "white", zIndex: 3, borderRadius: 10 }}
          key="5"
        >
          <span className="text">
            <TotalOfferperStatus />
          </span>
        </div>
        <div
          style={{ backgroundColor: "white", zIndex: 3, borderRadius: 10 }}
          key="6"
        >
          <span className="text">
            <TrenderQuatationsList />
          </span>
        </div>
        <div
          style={{ backgroundColor: "white", zIndex: 3, borderRadius: 10 }}
          key="7"
        >
          <span className="text">
            <OrdersSList />
          </span>
        </div>
      </ReactGridLayout>
    </div>
  );
};

export default ExtraLargeGrid;
